export default __webpack_public_path__ + "static/media/ganadores.81b6bb99.png";